import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

const Home = () => {
  const { pathname } = useLocation();
  const path = pathname.split('/')[1];

  return (
    <Container className="py-5">
      <Row className="justify-content-center mb-5">
        <Col md={10} className="text-center">
          <h1 className="display-4 fw-bold">
            {path === 'workshop' ? 'Pick the Gym For Workshop' : 'Pick Your Climbing Gym'}
          </h1>
          <div className="title-underline"></div>
        </Col>
      </Row>
      <Row className="g-4">
        <Col sm={12} md={4}>
          <div className="location-card">
            <div className="image-container">
              <img
                src="/assets/images/home/ikea-batu-kawan.png"
                alt="project-rock-ikea-batu-kawan"
                className="location-image"
                loading="lazy"
              />
              <div className="location-overlay">
                <a href={`/${path}/ikea-batu-kawan`} className="btn-explore">Enter</a>
              </div>
            </div>
            <div className="location-info">
              <h3>Project Rock</h3>
              <h4>IKEA Batu Kawan</h4>
            </div>
          </div>
        </Col>
        <Col sm={12} md={4}>
          <div className="location-card">
            <div className="image-container">
              <img
                src="/assets/images/home/gurney-plaza.png"
                alt="project-rock-gurney-plaza"
                className="location-image"
                loading="lazy"
              />
              <div className="location-overlay">
                <a href={`/${path}/gurney-plaza`} className="btn-explore">Enter</a>
              </div>
            </div>
            <div className="location-info">
              <h3>Project Rock</h3>
              <h4>Gurney Plaza</h4>
            </div>
          </div>
        </Col>
        <Col sm={12} md={4}>
          <div className="location-card-coming-soon">
            <div className="image-container">
              <img
                src="/assets/images/home/bayana.png"
                alt="project-rock-bayana"
                className="location-image"
                loading="lazy"
              />
              <div className="location-overlay">
                <span className="status-badge">Enter</span>
                {/* <a href={`/${path}/bayana`} className="btn-explore">Enter</a> */}
              </div>
            </div>
            <div className="location-info">
              <h3>Project Rock</h3>
              <h4>Bayana</h4>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  )
}

export default Home;